import React from 'react';
import RoundImage from './RoundImage';
import _ from 'lodash';
import ButtonLink from './ButtonLink';
import InviteParticipantButton from './InviteParticipantButton';

export default class ParticipantHeader extends React.PureComponent {
    render() {
        let {participant, event, i18n} = this.props,
            button;
        if (event && participant.user_id) {
            button = (
               <InviteParticipantButton event={event} participant={participant} />
            );
        }
        return (
            <div className="ParticipantHeader">
                <RoundImage className="avatar" src={participant.image_url} altSrc="img/no_avatar.png" size={56} />
                <div className="text name">{_.compact([participant.first_name, participant.last_name]).join(' ')}</div>
                {button}
            </div>
        );
    }
}
